import { styled } from 'styled-components';
import { extractNumber } from '../../../functions/utils/extractNumber';
import { useScene } from '../../../hooks';
import { UnitInput } from '../../common/inputs/UnitInput';

export const WindowProps = () => {
  const scene = useScene();

  return (
    <Container>
      <SizeContainer>
        <UnitInput
          id="window-width-input"
          label="w"
          value={scene.launcherWindow.windowWidth}
          units={[]}
          defaultUnit="px"
          onChange={(inputValue?: string | number) =>
            scene.setLauncherWindow((prev) => ({
              ...prev,
              windowWidth: Number(extractNumber(inputValue)),
            }))
          }
          centered
        />
        <UnitInput
          id="window-height-input"
          label="h"
          value={scene.launcherWindow.windowHeight}
          units={[]}
          defaultUnit="px"
          onChange={(inputValue?: string | number) =>
            scene.setLauncherWindow((prev) => ({
              ...prev,
              windowHeight: Number(extractNumber(inputValue)),
            }))
          }
          centered
        />
      </SizeContainer>
      {/* <SwitchInput
        id="window-resizable-input"
        label="Resizable"
        value={scene.launcherWindow.isWindowResizable}
        onChange={(inputValue: boolean) => {
          scene.setLauncherWindow((prev) => ({
            ...prev,
            isWindowResizable: inputValue,
          }));
        }}
      /> */}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  margin-bottom: 10px;
`;

const SizeContainer = styled.div<{ centered?: boolean }>`
  box-sizing: border-box;
  width: 100%;
  height: 25px;
  display: flex;
  gap: 10px;

  margin-bottom: 10px;
`;
